// extracted by mini-css-extract-plugin
export default {"payrollOverview-header":"Header_payrollOverview-header__7saQY","payrollOverview-header-item":"Header_payrollOverview-header-item__KaGpw"};